import React from 'react';

import { Typography } from '@mui/material';
import cx from 'classnames';

import useStyles from './styles';

interface CardAccompanyingInfoProps {
  text: string;
  className?: string;
}

const CardAccompanyingInfo: React.FC<CardAccompanyingInfoProps> = ({
  text,
  className,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Typography className={cx(classes.helperText, className)} {...rest}>
      {text}
    </Typography>
  );
};

export default CardAccompanyingInfo;
